import { useTable } from "react-table";
import styled from "styled-components";
import SimpleButton from "../Buttons/SimpleButton";

const TableContainer = styled.table`
  table-layout: fixed;
  width: 100%;
  padding: 5%;
`;
const TableHead = styled.thead`
  background: black;
`;

const TableRow = styled.tr<{ background: string }>`
  background: ${(props) => props.background};
`;

const TableHeader = styled.th`
  padding: 3%;
`;

const TableBody = styled.tbody``;

const TableData = styled.td`
  padding: 3%;
  word-wrap: break-word;
  text-align: center;
`;

interface TableProps {
  columns: Array<any>;
  data: Array<any>;
  onApproveClick: any;
}
export const Table = ({
  columns,
  data,
  onApproveClick,
}: TableProps) => {
  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      ...columns,
      {
        id: "Action",
        Header: "Action",
        Cell: ({ row }) => (
            <SimpleButton style={{marginLeft: 'auto', marginRight: 'auto'}}onClick={() => {onApproveClick(row.values)}}>
              Approve
            </SimpleButton>
        ),
      },
    ]);
  };
  const tableInstance = useTable({ columns, data }, tableHooks);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;

  const isEven = (idx) => idx % 2 === 0;

  return (
    <TableContainer {...getTableProps()}>
      <TableHead>
        {headerGroups.map((headerGroup) => (
          <TableRow {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <TableHeader {...column.getHeaderProps()}>
                {column.render("Header")}
              </TableHeader>
            ))}
          </TableRow>
        ))}
      </TableHead>
      <TableBody {...getTableBodyProps()}>
        {rows.map((row, idx) => {
          prepareRow(row);
          return (
            <TableRow
              {...row.getRowProps()}
              background={isEven(idx) ? "#424582" : "#595B9E"}
            >
              {row.cells.map((cell) => (
                <TableData {...cell.getCellProps()}>
                  {cell.render("Cell")}
                </TableData>
              ))}
            </TableRow>
          );
        })}
      </TableBody>
    </TableContainer>
  );
};
